export default __webpack_public_path__ + "static/media/Shot_31.0000.5d3de5e9.png";